<template>
  <div ref="telegramWidget" style="width: 100%"></div>
</template>

<script setup>
  import { ref, onMounted } from 'vue';
  import { Props } from './scripts/props.js';
  //----------------------------------------
  const props = defineProps(Props());
  //----------------------------------------
  const telegramWidget = ref(null);
  //----------------------------------------
  onMounted(() => {
    toRenderTelegram();
  })
  //----------------------------------------
  //Отрендерить телеграмм виджет
  const toRenderTelegram = () => {
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://telegram.org/js/telegram-widget.js?22';
    script.setAttribute('data-telegram-post', `${props.link}`);
    script.setAttribute('data-width', '100%');
    script.setAttribute('data-dark', `${localStorage.getItem('color_mode') == 'light' ? 0 : 1}`);
    telegramWidget.value.appendChild(script);
  }
</script>